var _path, _path2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgService1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 41,
    viewBox: "0 0 47 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.8458 5.64528H42.8142C44.524 5.64528 45.91 7.03131 45.91 8.74107V32.2628C45.91 33.9725 44.524 35.3586 42.8142 35.3586H26.8458C25.1361 35.3586 23.75 33.9725 23.75 32.2628V8.74107C23.75 7.03131 25.1361 5.64528 26.8458 5.64528Z",
    fill: "url(#paint0_linear_1_339)",
    stroke: "url(#paint1_linear_1_339)",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.84582 5.64528H19.8142C21.524 5.64528 22.91 7.03131 22.91 8.74107V32.2628C22.91 33.9725 21.524 35.3586 19.8142 35.3586H3.84582C2.13606 35.3586 0.750031 33.9725 0.750031 32.2628V8.74107C0.750031 7.03131 2.13606 5.64528 3.84582 5.64528Z",
    fill: "url(#paint2_linear_1_339)",
    stroke: "url(#paint3_linear_1_339)",
    strokeWidth: 0.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_1_339)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.3368 0H11.2756C9.42778 0 7.9298 1.49796 7.9298 3.34579V37.6542C7.9298 39.502 9.42778 41 11.2756 41H35.3368C37.1847 41 38.6826 39.502 38.6826 37.6542V3.34579C38.6826 1.49796 37.1847 0 35.3368 0Z",
    fill: "url(#paint4_linear_1_339)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2756 0.5H35.3368C36.9085 0.5 38.1826 1.7741 38.1826 3.34579V37.6542C38.1826 39.2259 36.9085 40.5 35.3368 40.5H11.2756C9.70392 40.5 8.4298 39.2259 8.4298 37.6542V3.34579C8.4298 1.77411 9.70392 0.5 11.2756 0.5Z",
    stroke: "url(#paint5_linear_1_339)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1_339",
    x: -10.0702,
    y: -18,
    width: 66.7528,
    height: 77,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 9
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1_339"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1_339",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_339",
    x1: 34.8316,
    y1: 52.2346,
    x2: 34.8316,
    y2: -6.78025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2447"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_339",
    x1: 25.0996,
    y1: 7.7715,
    x2: 49.8072,
    y2: 27.5851,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_339",
    x1: 11.8316,
    y1: 52.2346,
    x2: 11.8316,
    y2: -6.78025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2447"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_339",
    x1: 2.09957,
    y1: 7.7715,
    x2: 26.8072,
    y2: 27.5851,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1_339",
    x1: 9.66598,
    y1: 38.6853,
    x2: 44.5827,
    y2: 12.4954,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.49
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1_339",
    x1: 10.1006,
    y1: 3.22457,
    x2: 43.63,
    y2: 30.115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgService1);
export default __webpack_public_path__ + "static/media/service1.63dcb2a96fb90020ddae6ebb58deaa14.svg";
export { ForwardRef as ReactComponent };